import React from 'react';
import CreateView from './CreateView';
import GlobalParser from "./GlobalParser.js";
import { DynamicViewProps, DynamicViewState } from './iDynamicView';
import DynamicPlugin from './DynamicPlugin';
import Utils from './Utils';


// let API = require('./api.all');
// let CACHE_KEY = "YYCreatePage_";// 缓存的键值前缀
class DynamicView extends React.Component<DynamicViewProps, DynamicViewState> {
    // static API = API;
    static defaultProps = {
        appCode: null,
        pageCode: null,
        billCode: null, // 单据类型标识
        jsPluginUrl: null, // 二开扩展的js代码文件路径
        uiMeta: null,
        uiParser: null, // UI组件解析器{"ComponentName":Component,...} 1
        uiEvent: null, // UI事件处理器{"uikey":{"eventName":Function,...},...} 1
        uiParams: null, // UI参数解析器{"ParamName":Function,...}
        mode: null, // publish:发布状态 debug:调试状态（默认）
        serverUrl: null,
        // enableOrg: true, // 是否获取当前组织
        // enableCache: false, // 是否启用缓存
        // enableLoading: true// 是否启用加载中
    }

    constructor(props:DynamicViewProps) {
        super(props);
        this.state = {
            appCode: this.props.appCode,
            pageCode: this.props.pageCode,
            billCode: null,
            jsPluginUrl: this.props.jsPluginUrl, // 二开扩展的js文件访问路径
            uiMeta: this.props.uiMeta,
            uiParser: this.props.uiParser,
            uiEvent: this.props.uiEvent,
            uiParams: this.props.uiParams
        }
    }

    componentWillReceiveProps(nextProps:DynamicViewProps) {
        if ('uiMeta' in nextProps) {
            this.setState({
                uiMeta: nextProps.uiMeta
            });
        }
        if ('uiParams' in nextProps) {
            this.setState({
                uiParser: nextProps.uiParams
            });
        }
        if ('uiParser' in nextProps) {
            this.setState({
                uiParser: nextProps.uiParser
            });
        }
        if ('uiEvent' in nextProps) {
            this.setState({
                uiEvent: nextProps.uiEvent
            });
        }
        if ('jsPluginUrl' in nextProps) {
            this.setState({
                jsPluginUrl: nextProps.jsPluginUrl
            });
        }
        if ('appCode' in nextProps && 'pageCode' in nextProps) {
            // 当应用编码或页面编码变更时重新加载刷新页面
            if (this.props.appCode !== nextProps.appCode || this.props.pageCode !== nextProps.pageCode) {
                this.refreshPage(nextProps.appCode, nextProps.pageCode, null, null);
            }
        }
        // if ('location' in nextProps) {
        //     let query = this.props.location ? this.props.location.query : {};
        //     let nextQuery = nextProps.location ? nextProps.location.query : {};
        //     if (query.appCode !== nextQuery.appCode || query.pageCode !== nextQuery.pageCode) {
        //         this.refreshPage(nextProps.appCode, nextProps.pageCode, nextProps.location, null);
        //     }
        // }
        // if ('routeParams' in nextProps) {
        //     let query = this.props.routeParams ? this.props.routeParams : {};
        //     let nextQuery = nextProps.routeParams ? nextProps.routeParams : {};
        //     if (query.appCode !== nextQuery.appCode || query.pageCode !== nextQuery.pageCode) {
        //         this.refreshPage(nextProps.appCode, nextProps.pageCode, null, nextProps.routeParams);
        //     }
        // }
    }

    refreshPage = (appCode?:string|null|undefined, pageCode?:string|null|undefined, location?:any, routeParams?:any) => {
        let query = location ? location.query : {};
        if (routeParams) query = routeParams;
        // 如果属性不存在则取路由URL参数
        let _appCode = appCode ? appCode : query.appCode;
        let _pageCode = pageCode ? pageCode : query.pageCode;
        this.setState({appCode: _appCode, pageCode: _pageCode}); // 更新appCode|pageCode
        this._loadPageData(_appCode, _pageCode);
    }
    // 加载页面元数据
    _loadPageData = (appCode?:string, pageCode?:string) => {
        let self = this;
        if (!appCode || !pageCode) return;
        let {serverUrl, mode} = this.props;
        // let params = {
        //     appCode: appCode,
        //     pageCode: pageCode,
        //     mode: mode
        // };
        // // 是否启用自动获取当前组织和租户id
        // if (enableOrg) {
        //     params.orgId = AuthToken.getOrgaId();
        //     params.tenantId = AuthToken.getTenantId();
        // }
        // // 读取缓存(内存级)
        // let metaData = enableCache === false ? null : DataUtil.getCache(CACHE_KEY + appCode + "_" + pageCode);
        // if (metaData) {
        //     self.setState({
        //         uiMeta: _.cloneDeep(metaData), billCode: metaData.billCode
        //         , jsPluginUrl: (metaData.attachPathPro ? metaData.attachPathPro : self.state.jsPluginUrl)
        //     });
        // } else {
        DynamicPlugin.ajaxGetJson(`${serverUrl}?appCode=${appCode}&pageCode=${pageCode}&mode=${mode}`, function(result:any) {
            let data = null;
            if (result.success && result.backData && result.backData.data) {
                data = JSON.parse(result.backData.data);
                if (result.backData.orgId) {
                    console.warn('[按组织隔离加载页面]' + result.backData.orgId.name + '(' + result.backData.id + ')/' + appCode + '/' + pageCode);
                }
                self.setState({
                    uiMeta: Utils.isEmpty(data) ? null : data,
                    billCode: result.backData.billCode,
                    jsPluginUrl: (result.backData.attachPathPro ? result.backData.attachPathPro : self.state.jsPluginUrl)
                });
                // DataUtil.setCache(CACHE_KEY + appCode + "_" + pageCode, _.isEmpty(data) ? null : _.cloneDeep(data));// 存入缓存(内存级)
            } else {
                console.warn('[加载页面]' + appCode + '/' + pageCode + '/空页面');
            }
        });
        // }
    }

    componentDidMount() {
        let {appCode, pageCode /* , location, routeParams*/ } = this.props;
        this.refreshPage(appCode, pageCode /* , location, routeParams*/);
    }

    render() {
        // let {
        //     /*router, location, params, route, routeParams, routes, enableLoading,*/
        //     appCode, pageCode, uiParser, uiEvent, uiParams, mode, serverUrl /*, enableOrg, enableCache,*/
        //     // ...otherProps
        // } = this.props;
        let {appCode, pageCode, billCode, jsPluginUrl, uiParams, uiMeta, uiParser, uiEvent} = this.state;
        // let _props = Object.assign({router, location, params, route, routeParams, routes}, otherProps);
        // _props.uiParams = this.state.uiParams;
        // _props.uiMeta = this.state.uiMeta;
        // _props.uiParser = this.state.uiParser;
        // _props.uiEvent = this.state.uiEvent;
        if (this.state.uiMeta !== undefined) {
            return <CreateView
                appCode={appCode}
                pageCode={pageCode}
                billCode={billCode}
                jsPluginUrl={jsPluginUrl}
                globalParser={GlobalParser}
                uiMeta={uiMeta}
                uiParams={uiParams}
                uiParser={uiParser}
                uiEvent={uiEvent}
            />
        } else {
            // return enableLoading ? <YYSpin
            //     style={{height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}/> : null;
        }
    }
}

export default DynamicView
